export const STRINGS = {
    menu_button: "menu_button",
    scan_barcode: "scan_barcode"
}